var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.hasMsg && _vm.hasInfo)?_c('div',{staticClass:"py-2 my-1 mx-n3 px-3 mx-md-n9 px-md-9",staticStyle:{"border-top":"1px solid #eee"}},_vm._l((_vm.info),function(i){return _c('ShipmentInfoItem',{key:i.id,attrs:{"item":i}})}),1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }